export const sanitize = (value) =>
  value.replace(/[^\d.]/g, '');

export const format = (value) =>
  Number(value || 0).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });